export default "__VITE_ASSET__BOq4jtPG__"